import React from "react";
import Link from "next/link";

const toc = [
  {
    topic: "Was sind die beliebtesten Opel Modelle?",
    anchor: "was-sind-die-beliebtesten-opel-modelle",
  },
  {
    topic: "Besonderheiten von Opel",
    anchor: "besonderheiten-von-opel",
  },
  {
    topic: "Wem gehört Opel?",
    anchor: "wem-gehort-opel",
  },
  {
    topic: "Was bedeutet OPC?",
    anchor: "was-bedeutet-opc",
  },
  {
    topic: "Was bedeutet winterpaket bei Opel?",
    anchor: "was-bedeutet-winterpaket-bei-opel",
  },
  {
    topic: "Opel Privatkunden und Gewerbekunden Leasing",
    anchor: "opel-privatkunden-und-gewerbekunden-leasing",
  },
  {
    topic: "Opel Neuwagen oder Gebrauchtwagen Leasing?",
    anchor: "opel-neuwagen-oder-gebrauchtwagen-leasing",
  },
  {
    topic: "Was kostet eine Inspektion bei einem Opel Leasing* ?",
    anchor: "was-kostet-eine-inspektion-bei-einem-opel-leasing",
  },
  {
    topic: "Doch was wird bei einer Opel Inspektion gemacht?",
    anchor: "doch-was-wird-bei-einer-opel-inspektion-gemacht",
  },
  {
    topic: "Wie funktioniert die Leasingrückgabe bei einem Opel Leasing?",
    anchor: "wie-funktioniert-die-leasingruckgabe-bei-einem-opel-leasing",
  },
  {
    topic: "Die Mehrkilometer.",
    anchor: "die-mehrkilometer",
  },
  {
    topic: "Führen Gebrauchsspuren bei Leasingrückgabe zu Kosten?",
    anchor: "fuhren-gebrauchsspuren-bei-leasingruckgabe-zu-kosten",
  },
];

export default ({ minLeasingRate }) => (
  <div className="page-container page-container--tight px-5 mb-1">
    <h2 className="headline--4 mb-4">
      Opel Leasing - Das können die Opel Modelle!
    </h2>
    <p className="mb-4">
      So viele Fahrzeughersteller, wie soll man sich da nur entscheiden? Das Opel Leasing bietet
      ein super Preis-Leistungs-Verhältnis und kann dazu mehr als nur schnittige Kleinwagen zu
      bauen.
    </p>
    <p className="mb-4">
      Bei Null-Leasing finden sie alle Opel Modelle in der vollen Bandbreite. Die Opel Leasing
      Angebote gibt es als Opel Neuwagen und als Opel Gebrauchtwagen und das mit 0 €
      Anzahlung.
    </p>
    <p className="mb-4">
      Besonders beliebt sind die City Flitzer, wie der Opel Corsa oder der Opel Corsa E. Diese
      zeichnen sich durch ihre schnittige und junge Form aus und glänzen durch ein hohes Gebot
      an Fahrspaß . Finde Sie bei uns alle Informationen zu den besten Opel Modellen.
    </p>
    <ol className="mb-5 lg:mb-8">
      {toc.map(({ topic, anchor, subTopics }) => {
        if (subTopics && subTopics.length > 0) {
          return (
            <li key={anchor} className="text-secondary font-bold">
              {topic}
              <ul style={{ paddingLeft: "20px", listStyle: "disc" }}>
                {subTopics.map(({ topic, anchor }) => (
                  <li key={anchor} className="text-secondary font-bold">
                    <Link href={`#${anchor}`} className="link link--secondary">
                      {topic}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          );
        }
        return (
          <li key={anchor} className="text-secondary font-bold">
            <Link href={`#${anchor}`} className="link link--secondary">
              {topic}
            </Link>
          </li>
        );
      })}
    </ol>
    <div
      id="was-sind-die-beliebtesten-opel-modelle"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was sind die beliebtesten Opel Modelle?
      </h3>
      <p className="mb-4">
        Opel bietet ein breit gefächertes Sortiment an unterschiedlichen Fahrzeugtypen an. Von
        eleganten Limousinen, über sportliche Coupés, bis hin zu familienfreundlichen und
        komfortablen SUVs wie dem Opel Crossland oder dem Opel Grandland.
      </p>
      <p className="mb-4">
        Das derzeit günstigste Opel Modell ist der Opel Corsa mit einem Startpreis von 13.990 €
        oder x€ im Monat als Opel Leasing. Sollten Sie nach einer komfortablen Limousine suchen,
        die sowohl für die Stadt, als auch für längere Fahrten perfekt ist, dann sollten Sie den
        Opel Insignia in ihre engere Auswahl nehmen. Der Opel Insignia bietet eine optimale Mischung
        zwischen Komfort, Sicherheit und Eleganz. Auch den etwas geräumigeren Verwandten Opel
        Insignia Sportstourer bietet das Opel Leasing ohne Anzahlung. Dieser Zeichnet sich durch
        sein abgeflachtes Heck aus und bietet so den Kombi typischen Stauraum.
      </p>
      <p className="mb-4">
        Wem eine Limousine doch zu klein sein sollte, kann auf den geräumigen Opel Crossland
        zurückgreifen. Dieser bietet mit seinem erhöhten Einstieg einen leichten und komfortablen
        Umgang und ist perfekt für Familien. Den Opel Crossland kriegen Sie als Opel Leasing
        bereits ab
        {" "}
        {minLeasingRate}
        {" "}
        auf Null-Leasing.
      </p>
    </div>
    <div
      id="besonderheiten-von-opel"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Besonderheiten von Opel
      </h3>
      <p className="mb-4">
        Das aus Rüsselsheim stammende Unternehmen ist bekannt für seine Preis-Leistung starken
        Kraftfahrzeuge und seine simple und dennoch moderne Art. Die Marke mit dem Blitz ist seit
        über 90 Jahren auf dem Markt und hat mit Fahrzeugen wie dem Opel Kadett oder dem Opel
        Manta mehrere Generationen an Autofanatikern geprägt. So ist Opel als Marke vom
        europäischen Markt kaum noch wegzudenken.
      </p>
    </div>
    <div
      id="was-bedeutet-opc"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was bedeutet OPC?
      </h3>
      <p className="mb-4">
        Der Deutsche Kraftfahrzeughersteller Opel gehört zu der Niederländischen
        Aktiengesellschaft Stellantis. Der multinationale Automobilkonzern Stellantis beherbergt 14
        Automarken unter einem Dach, zu dem Marken wie Opel, Peugeot, Jeep und viele weitere
        zählen.
      </p>
    </div>
    <div
      id="wem-gehort-opel"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Wem gehört Opel?
      </h3>
      <p className="mb-4">
        Mit der Performance Linie von Opel (OPC) setzte Opel ein Zeichen in Sache Sportlichkeit.
        Die Performance Linie ist seit der Einführung in 1999 immer noch ein Schmaus im Auge
        vieler, die auf viel PS und Sportlichkeit für einen schmalen Taler stehen. Sie überzeugt
        besonders durch die Tuning ähnliche Optik und Elementen wie einem Heckspoiler, wie bei
        dem Opel Astra OPC. Die sportlichen Performance-Fahrzeuge gibt es als Neuwagen, Opel
        Jahreswagen und als Gebrauchtwagen bei Null-Leasing.
      </p>
    </div>
    <div
      id="was-bedeutet-winterpaket-bei-opel"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was bedeutet winterpaket bei Opel?
      </h3>
      <p className="mb-4">
        Das Winterpaket von Opel beinhaltet beheizte Scheibenwaschdüsen, beheizte Vordersitze
        und die beheizbare Scheinwerferreinigungsanlage. Bei manchen Angeboten beinhaltet das
        Winterpaket von Opel ebenfalls ein beheizbares Lenkrad und eine beheizbare Frontscheibe.
        Die Ausstattungen können je nach Opel Modell und Konfiguration abweichungen enthalten.
        Überprüfen Sie daher bei ihrer Konfiguration ob diese Features bereits mit enthalten sind.
      </p>
    </div>
    <div
      id="opel-privatkunden-und-gewerbekunden-leasing"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Opel Privatkunden und Gewerbekunden Leasing
      </h3>
      <p className="mb-4">
        Bei einem Privatkunden Leasing von Null-Leasing.com profitieren Sie von den Vorteilen
        eines Leasingfahrzeuges und das ganz ohne Anzahlungen. Mit unserem breitgefächerten
        Opel Leasing Angebot, haben Sie die volle Auswahl an Opel Modellen und können mit hilfe
        unseres kundenfreundlichen Systems innerhalb von kürzester Zeit bei einem der vielen
        Neuwagen und Gebrauchtwagen Deals zuschlagen. Doch nicht nur für Privatpersonen ist
        ein Opel Leasing ohne Anzahlung interessant. Besonders die Gewerbekunden profitieren
        von den verschiedenen Opel Leasing Angeboten von Null-Leasing.
      </p>
      <p className="mb-4">
        Für Gewerbekunden sind die Opel Leasing Angebote ebenfalls ohne Anzahlung, mit dem
        Vorteil, dass Sie die das Fahrzeug von der Steuer absetzen können. Durch den Entfall der
        Mehrwertsteuer können Gewerbekunden so auf noch günstigere Leasingangebote
        zugreifen. Des Weiteren ist die Leasinglaufzeit bei manchen Angeboten anpassbar auf bis
        zu 36 Monaten. Wer doch einen häufigen Fahrzeugwechsel bevorzugt, der kann die
        Leasinglaufzeit auf 24 Monate verringern und so alle zwei Jahre das Fahrzeug wechseln.
      </p>
    </div>
    <div
      id="opel-neuwagen-oder-gebrauchtwagen-leasing"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Opel Neuwagen oder Gebrauchtwagen Leasing?
      </h3>
      <p className="mb-4">
        Mit dem Gebrauchtwagen Leasing von Null-Leasing garantieren wir Ihnen junge
        Gebrauchtwagen, zu günstigen Preisen. Ungleich zu dem Kauf eines Gebrauchtwagens
        haben Sie bei einem Opel Gebrauchtwagen Leasing die Absicherung, dass der junge
        Gebrauchtwagen in einem perfekten Zustand ist, ohne versteckte Mängel! Die Abholung des
        Opel-Gebrauchtwagens erfolgt dabei über den jeweiligen Händler.
      </p>
      <p className="mb-4">
        Das Null-Leasing Neuwagen Leasing bietet Ihnen ein breitgefächertes Angebot an den
        neuesten Opel Modellen. Die Neuwagen Angebote reichen von Bestand Fahrzeugen bis hin
        zu frei konfigurierbaren Neuwagen inklusive Werksabholung. Mit den Neuwagen und
        Gebrauchtwagen Angeboten von Null-Leasing können Sie sich sofort verfügbare Opel
        Modelle sichern, die Sie kurz nach Abschluss des Vertrages abholen können.
      </p>
    </div>
    <div
      id="was-kostet-eine-inspektion-bei-einem-opel-leasing"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was kostet eine Inspektion bei einem Opel Leasing* ?
      </h3>
      <p className="mb-4">
        Das kostet eine Inspektion bei Opel.
      </p>
      <p className="mb-4">
        Bei Opel liegen die durchschnittlichen Kosten bei einer kleinen Inspektion bei 150 €. Bei
        einer große Inspektion liegen die kosten im Durchschnitt bei bis zu 400 € und beinhaltet
        einen umfangreichen Service. Die genauen Inspektionskosten können anhand des Modells
        auf Anfrage bei einer verifizierten Werkstatt konkret ermittelt werden.
      </p>
    </div>
    <div
      id="doch-was-wird-bei-einer-opel-inspektion-gemacht"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Doch was wird bei einer Opel Inspektion gemacht?
      </h3>
      <p className="mb-4">
        Bei einer Opel Inspektion werden Teile auf ihren Verschleiß geprüft und diese bei Bedarf
        ausgetauscht. Dazu zählen Zündkerzen, Luftfilter, kaputte Lichter und ähnliches. Des
        weiteren werden verschiedene Flüssigkeiten gewechselt und aufgefüllt, wie Getriebeöl,
        Bremsflüssigkeit und Scheibenwischwasser.
      </p>
      <p className="mb-4">
        Bei weiteren Fragen zum Thema Inspektion und Wartung, sowie zu den verschiedenen
        Fahrzeugmodellen können Sie sich auf der
        {" "}
        <a
          className="link link--secondary"
          href="https://www.opel.de/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Opel
        </a>
        {" "}
        Seite erkundigen und sich kostenlos beraten
        lassen.
      </p>
    </div>
    <div
      id="wie-funktioniert-die-leasingruckgabe-bei-einem-opel-leasing"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Wie funktioniert die Leasingrückgabe bei einem Opel Leasing?
      </h3>
      <p className="mb-4">
        Die Rückgabe des Opel Leasingfahrzeugs erfolgt unkompliziert nach Ende der Leasinglaufzeit,
        bei dem jeweiligen Händler. Im Gegensatz zu dem herkömmlichen Kauf eines Autos muss
        man sich bei einem Privat- oder Gewerbe-Leasing bei Tausch oder Abgabe keine Sorgen um
        den Verkauf des Autos machen.
      </p>
      <p className="mb-4">
        Auf eins sollte bei einem Opel Leasing dennoch geachtet werden, um Kosten zu vermeiden.
      </p>
    </div>
    <div
      id="die-mehrkilometer"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Die Mehrkilometer.
      </h3>
      <p className="mb-4">
        Die Höhe der Kosten für Mehrkilometer werden bei Vertragsabschluss festgelegt, sodass es
        auch hier keine bösen Überraschungen entstehen. Jedoch sollte trotzdem darauf geachtet
        werden, dass die vorgegebene Laufleistung nicht überschritten wird, um Unsicherheiten
        gegen Vertragsende zu vermeiden.
      </p>
    </div>
    <div
      id="fuhren-gebrauchsspuren-bei-leasingruckgabe-zu-kosten"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Führen Gebrauchsspuren bei Leasingrückgabe zu Kosten?
      </h3>
      <p className="mb-4">
        Bei einer durchschnittlichen Abnutzung des Opel-Fahrzeuges (normale Gebrauchsspuren)
        entstehen keine weiteren Kosten für Sie. Wir empfehlen dennoch das Leasing Auto vor der
        Rückgabe professionell aufbereiten zu lassen, um das Risiko von potenziellen Kosten zu
        minimieren.
      </p>
      <p className="mb-4">
        Bei weiteren Fragen zu Opel Leasing Rückgabe kontaktieren Sie uns unter unserer
        Service-Hotline 040 5379869 10 oder in unseren
        {" "}
        <a
          className="link link--secondary"
          href="/faq/wie-funktioniert-die-rueckgabe-nach-ende-der-leasingzeit"
          target="_blank"
        >
          Leasing Rückgabe FAQ
        </a>
        .
      </p>
    </div>
  </div>
);
